import { Section } from "..";
import SettingsSectionControl from "./SettingsSectionControl";

function SidebarFooter() {
  return (
    <Section data-sidebar="footer">
      <SettingsSectionControl />
    </Section>
  );
}

export default SidebarFooter;
